/** Stable decorative distribution: scene and parchment map share the same marks. */
import {region} from '../../../shared/regions.mjs';
export function terrainRoadDepth(id:string,x:number):number{return region(id)?.view==='district'?Math.sin(x*.0038)*65+Math.sin(x*.011)*18:0;}
export function terrainPlan(id:string){
 let seed=[...id].reduce((a,c)=>(a*31+c.charCodeAt(0))>>>0,719);
 const random=()=>{seed=(Math.imul(seed,1664525)+1013904223)>>>0;return seed/4294967296;};
 const marks=Array.from({length:1800},()=>{const x=random()*2800,z=random()*1120-560;return{x,z,size:3+random()*13,kind:random()};}).filter(p=>Math.abs(p.z)>145);
 return {marks,water:id==='nong-khai-road'?{x:2020,z:300,rx:150,rz:125}:undefined};
}
